"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingPoolHelper = void 0;
var provider_1 = require("../utils/provider");
var bmath_1 = require("../bmath");
var bignumber_1 = require("../utils/bignumber");
var multicall_1 = require("./multicall");
var constants_1 = require("../constants");
var StakingPoolHelper = /** @class */ (function () {
    function StakingPoolHelper(provider, network, pool, userAddress) {
        this.network = network;
        this.pool = pool;
        this.userAddress = userAddress;
        this.lastUpdate = 0;
        this.provider = provider_1.toProvider(provider);
    }
    Object.defineProperty(StakingPoolHelper.prototype, "stakingToken", {
        get: function () {
            return this.pool.stakingToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StakingPoolHelper.prototype, "rewardsAddress", {
        get: function () {
            return this.pool.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StakingPoolHelper.prototype, "rewardsFactoryAddress", {
        get: function () {
            if (this.pool.indexPool.toLowerCase() == constants_1.DEGEN.toLowerCase()) {
                return constants_1.SIGMA_REWARDS_FACTORY;
            }
            return this.network == 'mainnet'
                ? '0x48887E27e3E42e769F34e1e43E857235035d333a'
                : '0x8d12A344580Bc0bC4E684248067F5d9d3908C864';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StakingPoolHelper.prototype, "shouldUpdate", {
        get: function () {
            var timestamp = Math.floor(+new Date() / 1000);
            return timestamp - this.lastUpdate > 120;
        },
        enumerable: false,
        configurable: true
    });
    StakingPoolHelper.prototype.waitForUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.updatePromise = this.updatePool();
                            this.lastUpdate = Math.floor(+new Date() / 1000);
                        }
                        return [4 /*yield*/, this.updatePromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StakingPoolHelper.prototype.setUserAddress = function (address) {
        this.userAddress = address;
        this.updatePromise = this.updatePool();
        this.lastUpdate = Math.floor(+new Date() / 1000);
    };
    StakingPoolHelper.prototype.updatePool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var update, active, isReady, hasBegun, totalSupply, rewardsDuration, periodStart, periodFinish, lastUpdateTime, claimedRewards, rewardRate, rewardPerToken, userBalanceRewards, userEarnedRewards, userBalanceStakingToken, userAllowanceStakingToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, multicall_1.getStakingRewardsData(this.provider, this.pool, this.rewardsFactoryAddress, this.userAddress)];
                    case 1:
                        update = _a.sent();
                        active = update.active, isReady = update.isReady, hasBegun = update.hasBegun, totalSupply = update.totalSupply, rewardsDuration = update.rewardsDuration, periodStart = update.periodStart, periodFinish = update.periodFinish, lastUpdateTime = update.lastUpdateTime, claimedRewards = update.claimedRewards, rewardRate = update.rewardRate, rewardPerToken = update.rewardPerToken, userBalanceRewards = update.userBalanceRewards, userEarnedRewards = update.userEarnedRewards, userBalanceStakingToken = update.userBalanceStakingToken, userAllowanceStakingToken = update.userAllowanceStakingToken;
                        this.userBalanceRewards = userBalanceRewards;
                        this.userEarnedRewards = userEarnedRewards;
                        this.userBalanceStakingToken = userBalanceStakingToken;
                        this.userAllowanceStakingToken = userAllowanceStakingToken;
                        Object.assign(this.pool, {
                            active: active,
                            hasBegun: hasBegun,
                            isReady: isReady,
                            totalSupply: totalSupply,
                            rewardsDuration: rewardsDuration,
                            periodStart: periodStart,
                            periodFinish: periodFinish,
                            lastUpdateTime: lastUpdateTime,
                            claimedRewards: claimedRewards,
                            rewardRate: rewardRate,
                            rewardPerToken: rewardPerToken
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    StakingPoolHelper.prototype.calculateTotalRewardsForDuration = function (duration) {
        return this.pool.rewardRate.times(duration);
    };
    StakingPoolHelper.prototype.calculateRewardsForDuration = function (duration, stakedAmount) {
        if (stakedAmount === void 0) { stakedAmount = bmath_1.BONE; }
        var staked = bignumber_1.toBN(stakedAmount);
        return this.pool.rewardRate.times(duration).times(staked).div(this.pool.totalSupply);
    };
    return StakingPoolHelper;
}());
exports.StakingPoolHelper = StakingPoolHelper;
